import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import ProductImage from '../components/ProductImage';

const ShopCart = () => {
  const { cartItems, cartTotal, removeFromCart, updateQuantity, clearCart } = useCart();

  const handleDecreaseQuantity = (event, item) => {
    event.preventDefault();
    if (item.quantity > 1) {
      updateQuantity(item.ProductId, item.quantity - 1);
    }
  };

  const handleIncreaseQuantity = (event, item) => {
    event.preventDefault();
    updateQuantity(item.ProductId, item.quantity + 1);
  };

  return (
    <div className="container mb-30 mt-20">
      <div className="row">
        <div className="col-lg-8 mb-40">
          <h1 className="heading-2 mb-10">Your Cart</h1>
          <div className="d-flex justify-content-between">
            <h6 className="text-body">
              There are <span className="text-brand">{cartItems.length}</span> products in your cart
            </h6>
            {cartItems.length > 0 ? (
              <h6 className="text-body">
                <button type="button" className="text-muted border-0 bg-transparent p-0" onClick={clearCart}>
                  <i className="fi-rs-trash mr-5"></i>
                  Clear Cart
                </button>
              </h6>
            ) : null}
          </div>
        </div>
      </div>

      {cartItems.length === 0 ? (
        <div className="row">
          <div className="col-12 text-center py-5">
            <h5 className="mb-20">No products in your cart.</h5>
            <Link className="btn" to="/">
              <i className="fi-rs-arrow-left mr-10"></i>
              Continue Shopping
            </Link>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-lg-8">
            <div className="table-responsive shopping-summery">
              <table className="table table-wishlist">
                <thead>
                  <tr className="main-heading">
                    <th scope="col" colSpan="2">Product</th>
                    <th scope="col">Unit Price</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Subtotal</th>
                    <th scope="col" className="end">Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item) => (
                    <tr key={item.ProductId} className="pt-30">
                      <td className="image product-thumbnail pt-40">
                        <Link to={`/product-detail/${item.ProductId}`}>
                          <ProductImage src={item.DefaultImage} alt={item.ProductName} />
                        </Link>
                      </td>
                      <td className="product-des product-name">
                        <h6 className="mb-5">
                          <Link className="product-name mb-10 text-heading" to={`/product-detail/${item.ProductId}`}>
                            {item.ProductName}
                          </Link>
                        </h6>
                        <span className="font-small text-muted">{item.SubCategoryName || 'Product'}</span>
                      </td>
                      <td className="price" data-title="Price">
                        <h4 className="text-body">
                          <i className="fa fa-inr fs-10" aria-hidden="true"></i>
                          {item.Price.toLocaleString('en-IN')}
                        </h4>
                      </td>
                      <td className="text-center detail-info" data-title="Stock">
                        <div className="detail-extralink mr-15">
                          <div className="detail-qty border radius">
                            <a href="/" className="qty-down" onClick={(event) => handleDecreaseQuantity(event, item)}>
                              <i className="fi-rs-angle-small-down"></i>
                            </a>
                            <input type="text" name="quantity" className="qty-val" value={item.quantity} min="1" readOnly />
                            <a href="/" className="qty-up" onClick={(event) => handleIncreaseQuantity(event, item)}>
                              <i className="fi-rs-angle-small-up"></i>
                            </a>
                          </div>
                        </div>
                      </td>
                      <td className="price" data-title="Price">
                        <h4 className="text-brand">
                          <i className="fa fa-inr fs-10" aria-hidden="true"></i>
                          {(item.Price * item.quantity).toLocaleString('en-IN')}
                        </h4>
                      </td>
                      <td className="action text-center" data-title="Remove">
                        <button
                          type="button"
                          className="text-body border-0 bg-transparent p-0"
                          onClick={() => removeFromCart(item.ProductId)}
                        >
                          <i className="fi-rs-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="divider-2 mb-30"></div>
            <div className="cart-action d-flex justify-content-between">
              <Link className="btn" to="/">
                <i className="fi-rs-arrow-left mr-10"></i>
                Continue Shopping
              </Link>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="border p-md-4 cart-totals ml-30">
              <div className="table-responsive">
                <table className="table no-border">
                  <tbody>
                    <tr>
                      <td className="cart_total_label">
                        <h6 className="text-muted">Subtotal</h6>
                      </td>
                      <td className="cart_total_amount">
                        <h4 className="text-brand text-end">
                          <i className="fa fa-inr fs-10" aria-hidden="true"></i>
                          {cartTotal.toLocaleString('en-IN')}
                        </h4>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <div className="divider-2 mt-10 mb-10"></div>
                      </td>
                    </tr>
                    <tr>
                      <td className="cart_total_label">
                        <h6 className="text-muted">Shipping</h6>
                      </td>
                      <td className="cart_total_amount">
                        <h5 className="text-heading text-end">Free</h5>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <div className="divider-2 mt-10 mb-10"></div>
                      </td>
                    </tr>
                    <tr>
                      <td className="cart_total_label">
                        <h6 className="text-muted">Total</h6>
                      </td>
                      <td className="cart_total_amount">
                        <h4 className="text-brand text-end">
                          <i className="fa fa-inr fs-10" aria-hidden="true"></i>
                          {cartTotal.toLocaleString('en-IN')}
                        </h4>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Link to="/shop-checkout" className="btn mb-20 w-100">
                Proceed To CheckOut
                <i className="fi-rs-sign-out ml-15"></i>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShopCart;
